import React from 'react';

// (String) => JSX
export const newlinesToDivs = string =>
  string.split('\\n').map(line => <div>{line}</div>);
